// Lightweight analytics — fire-and-forget POST to /api/track
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackEvent = (event, meta = {}) => {
    try {
        axios.post(`${API}/track`, { event, meta }).catch(() => {});
    } catch {
        /* never block the user */
    }
};
